
//preload
var mobileViewport = window.matchMedia("screen and (max-width: 768px)"),
    srcLink= 'src';

mobileViewport.addListener(function(mq) {

    if(mq.matches) {
        srcLink = 'src-mobile';
    }
    else {
        srcLink = 'src';
    }

});

if(mobileViewport.matches) {
    srcLink = 'src-mobile';
}
else {
    srcLink = 'src';
}

var preload = function () {

        var preloadCheck = function () {

            $('.__js_preload').each(function (n) {

                var srcS;

                if($(this).isOnScreen()) {

                    if ( $(this).data('src-mobile') ){
                        srcS = $(this).data(srcLink);

                        $(this).css('opacity', '.8').delay(80).css('content', 'url(' + srcS + ')').animate({opacity: 1},1550);
                        $(this).removeClass('__js_preload').attr('src', srcS);
                        $(this).addClass('__js_preloaded');
                    }
                    else {
                        srcS = $(this).data('src');
                        $(this).css('opacity', '.9').attr('src', srcS).animate({opacity: 1},450);
                        $(this).removeClass('__js_preload');
                        $(this).addClass('__js_preloaded');
                    };

                }

            });
            setTimeout(preloadCheck, 250);
        };
     setTimeout(preloadCheck, 500);
 };
if($('.__js_preload').length){
    preload();
}
